import React, { Component } from "react"
// eslint-disable-line no-unused-vars
import Slider from "../slider/slider"
import { isMobile } from "react-device-detect"

import "./_spot-button-slider.scss"

class SpotButtonSlider extends Component {
  static defaultProps = {
    modifier: "",
  }

  // constructor(props) {
  // 	super(props);
  // }

  render() {
    let params = {
      freeMode: isMobile,
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3,
      },
    }

    return (
      <div className={`spot-button-slider`}>
        <Slider params={params}>{this.props.children}</Slider>
      </div>
    )
  }
}

export default SpotButtonSlider
